
import { Vue, Component, Watch } from 'vue-property-decorator';
import SearchBar from '@/components/next/SearchBar.vue';
import { getVoteList, getBaseInfo } from '../api';
import { List, Lazyload, Dialog, Toast } from 'vant';
Vue.use(List)
  .use(Lazyload)
  .use(Dialog)
  .use(Toast);
@Component({
  components: {
    SearchBar,
  },
})
export default class Home extends Vue {
  inStream: any = ['小学组', '初中组'];
  search = '';
  list: any[] = [];
  page = 1;
  loading = false;
  finished = false;
  loadingStatus = true;
  refreshing: boolean = false;
  show: boolean = true;
  time1: boolean = false;
  time2: boolean = false;
  time3: boolean = false;
  bannerImg: string = '';
  baseInfo: any = {};
  currentMediaType: number = 0; // 0: 绘画, 1: 视频

  @Watch('currentMediaType')
  onMediaTypeChange(val: number) {
    this.onSearch(); // 监听类型变化，重新搜索
  }

  changeMediaType(type: number) {
    if (this.currentMediaType === type) { return; }
    this.currentMediaType = type;
  }

  changeTab(item: any) {
    this.list = [];
    this.page = 1;
    this.loading = false;
    this.finished = false;
    this.loadingStatus = true;
    this.refreshing = false;
    this.show = false;
    setTimeout(() => {
      this.show = true;
    }, 500);
  }
  async onLoad() {
    const ret = await getBaseInfo();
    this.baseInfo = ret.data;
    getVoteList(this.page, this.search, this.currentMediaType === 0 ? 1 : 2).then((res: any) => {
      this.endListData(res);
    });
  }
  endListData(res: any) {
    this.page = this.page + 1;
    if (res.data.length === 0 || res.data.length === 0) {
      this.finished = true;
    } else {
      this.list = [...this.list, ...res.data];
    }
    this.loading = false;
  }
  onSearch() {
    this.finished = false;
    this.page = 1;
    this.list = [];
    this.show = false;
    setTimeout(() => {
      this.show = true;
    }, 500);
  }
  userInputChange(text: string) {
    this.search = text;
  }
  clear() {
    this.list = [];
    this.page = 1;
    this.finished = false;
  }
  goDetail(id: any) {
    this.$router.push(`homeDetail?id=${id}`);
  }
}
